function injectStyle (ssrContext) {
  require("!!../../../../../../../../xbz-pcfront-tech/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../../../xbz-pcfront-tech/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-048031c3\",\"scoped\":true,\"hasInlineConfig\":false}!less-loader?{\"sourceMap\":true}!../../../../../../../../xbz-pcfront-tech/node_modules/vue-loader/lib/selector?type=styles&index=0!./shrinkable-menu.vue")
}
var normalizeComponent = require("!../../../../../../../../xbz-pcfront-tech/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../../../../xbz-pcfront-tech/node_modules/vue-loader/lib/selector?type=script&index=0!./shrinkable-menu.vue"
import __vue_script__ from "!!babel-loader!../../../../../../../../xbz-pcfront-tech/node_modules/vue-loader/lib/selector?type=script&index=0!./shrinkable-menu.vue"
/* template */
import __vue_template__ from "!!../../../../../../../../xbz-pcfront-tech/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-048031c3\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../../../../../xbz-pcfront-tech/node_modules/vue-loader/lib/selector?type=template&index=0!./shrinkable-menu.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-048031c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/main-components/shrinkable-menu/shrinkable-menu.vue
// module id = null
// module chunks = 